export function parseUtcTimestamp(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return Number.NaN;
  const normalized = /(?:z|[+-]\d{2}:\d{2})$/i.test(raw) ? raw : `${raw}Z`;
  return Date.parse(normalized);
}

const jalaliDateTimeFormatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
});

function localJalaliParts(date) {
  return Object.fromEntries(
    jalaliDateTimeFormatter.formatToParts(date)
      .filter(part => part.type !== 'literal')
      .map(part => [part.type, part.value])
  );
}

export function formatLocalJalali(value, mode = 'datetime') {
  const timestamp = parseUtcTimestamp(value);
  if (!Number.isFinite(timestamp)) return null;
  const parts = localJalaliParts(new Date(timestamp));
  const date = `${parts.year}/${parts.month}/${parts.day}`;
  const time = `${parts.hour}:${parts.minute}`;
  if (mode === 'date') return date;
  if (mode === 'time') return time;
  return `${date} ${time}`;
}

export function hydrateLocalDateTimes(root = document) {
  const candidates = [];
  if (root instanceof Element && root.matches('[data-local-date-time]')) candidates.push(root);
  root.querySelectorAll?.('[data-local-date-time]:not([data-localized])').forEach(element => candidates.push(element));
  candidates.forEach(element => {
    const formatted = formatLocalJalali(element.getAttribute('datetime'), element.dataset.localDateTime);
    if (!formatted) return;
    element.textContent = formatted;
    element.dataset.localized = 'true';
    element.title = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Local time';
  });
}
